import React, { useState, useEffect, useRef } from 'react';
import {
    Typography, Box, IconButton, Button, Stack,
    Chip, Tooltip, Badge, Divider,
} from '@mui/material';
import { Link, useNavigate } from "react-router-dom";

import Iconify from '../../components/iconify';
import Icon from '@mui/material/Icon';
import MenuIcon from '@mui/icons-material/Menu';
import { useTournamentContext } from './../../context';

import { styled } from '@mui/material/styles';
import axios from '../../utils/axios';

const Coach = ({ coach, refresh }) => {
  const { tournament, apiURL } = useTournamentContext();

  const setDelivered = (e) => {
      axios.post(apiURL(`coaches/${coach.id}/delivered`)).then(refresh)
  }

  const unsetDelivered = (e) => {
      axios.delete(apiURL(`coaches/${coach.id}/delivered`)).then(refresh)
  }

  const setCollected = (e) => {
      axios.post(apiURL(`coaches/${coach.id}/collected`)).then(refresh)
  }

  const unsetCollected = (e) => {
      axios.delete(apiURL(`coaches/${coach.id}/collected`)).then(refresh)
  }


    return (
        <>
        <Stack direction="column" style={{width: '100%'}}>
            <Stack direction="row" spacing={2} alignItems="center">
                <Chip color="warning" label={`ID: ${coach?.coach?.id}`} />
                <Stack direction="column">
                    <Typography>
                        {coach?.coach?.name}&nbsp;
                    </Typography>
                </Stack>
            </Stack>

            <Stack direction="row" spacing={2} alignItems="center" style={{marginTop: '15px'}}>
                <Tooltip title={`${coach?.participants?.length} учасників`}>
                    <Badge badgeContent={`${coach?.participants?.length}/${coach?.unique_dancers_count}`} color="primary" showZero>
                        <IconButton>
                            <Iconify icon="fxemoji:dancer" />
                        </IconButton>
                    </Badge>
                </Tooltip>
                <Tooltip title={`${coach?.total_bookings_count ?? 0} бронювань`}>
                    <Badge badgeContent={coach?.total_bookings_count ?? 0} color="primary" showZero>
                        <IconButton>
                            <Iconify icon="twemoji:house" />
                        </IconButton>
                    </Badge>
                </Tooltip>
                <Tooltip title={`${coach?.total_tickets_count} квитків`}>
                    <Badge badgeContent={`${coach?.count_free_tickets ?? 0}/${coach?.total_tickets_count}`} color="primary" showZero>
                        <IconButton>
                            <Iconify icon="emojione-v1:ticket" />
                        </IconButton>
                    </Badge>
                </Tooltip>
            </Stack>

            <Stack direction="row" spacing={1}>
            {!coach?.documents_collected_at && !coach?.documents_delivered_at && (
                <Button size="small" variant="contained" color="secondary" onClick={(e) => setCollected(e)}>Сформувати документи</Button>
            )}
            {!!coach?.documents_collected_at && !coach?.documents_delivered_at && (
                <Stack direction="row" spacing={2} alignItems="center">
                <Button size="small" variant="contained" color="warning" onClick={(e) => unsetCollected(e)}>Скасувати сформовані документи {coach?.documents_collected_at.substring(0, 16)}</Button>
                <Button size="small" variant="contained" color="success" onClick={(e) => setDelivered(e)}>Видати документи</Button>
                </Stack>
            )}
            {coach?.documents_delivered_at && (
                <Button size="small" variant="contained" color="error" onClick={(e) => unsetDelivered(e)}>Скасувати видачу документів {coach?.documents_delivered_at.substring(0, 16)}</Button>
            )}
            </Stack>
        </Stack>
        <Divider />
        </>
    )
}


export default Coach;
